import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened the leads form',
  name: 'lead_form_opened',
  params: [
    {
      description: "The user's current plan when opening the leads form",
      name: 'plan',
      required: true,
      type: 'string',
    },
    {
      description: 'The trigger that opened the leads form',
      name: 'trigger',
      required: true,
      type: 'enum',
      values: [
        'plans_modal_v1_book_demo',
        'plans_modal_business',
        'plans_modal_enterprise',
        'credit_meter',
        'credit_popover',
        'credit_banner',
        'current_plan_upgrade_button',
      ],
    },
  ],
};

export default META;
